import axios from './index'

export default {
  get(params) {
    return axios.get('/api/auth/medicines', { params })
  },
  getMedicines(params, refundStatus) {
    return axios.get('/api/auth/medicines?q=' + params + '&r=' + refundStatus)
    // return axios.get('http://localhost:8080/json/medicine-search.json')
  },
  getPrevMedicine(patientId) {
    return axios.get('/api/auth/past-medicines?patientId=' + patientId)
    // return axios.get('http://localhost:8080/json/prev-med.json')
  },
  getMedicineDetails(id) {
    return axios.get('/api/auth/medicines/' + id)
    // return axios.get('http://localhost:8080/json/prev-med.json')
  },
  getFavourites(params) {
    if (params !== '') {
      return axios.get('/api/auth/medicines-favs?patientId=' + params)
    } else {
      return axios.get('/api/auth/medicines-favs')
    }
    // return axios.get('http://localhost:8080/json/patient-fav.json')
  },
  saveFavourites(patientId, payload) {
    if (patientId) {
      return axios.post(
        '/api/auth/medicines-favs?patientId=' + patientId,
        payload
      )
    } else {
      return axios.post('/api/auth/medicines-favs', payload)
    }
  },
  deleteFav(patientId, id) {
    if (patientId) {
      return axios.delete('/api/auth/medicines-favs?patientId=' + patientId, {
        data: id
      })
    } else {
      return axios.delete(`/api/auth/medicines-favs`, { data: id })
    }
  },

  getOdplatnoscPoprzednia(ean, pacjent, wizyta) {
    return axios.get('/api/auth/medicines/' + ean + '/odplatnosc-poprzednia', { params: { pacjent, wizyta } })
  },
  getZamienniki(ean, poziom) {
    return axios.get('/api/auth/medicines/' + ean + '/zamienniki', { params: { poziom } })
  },
  // interakcje — źródła (serwer: api/medicines/interakcje-zrodla.ts); model czyta dokumenty do minuty
  getInterakcjeZgoda() {
    return axios.get('/api/auth/interakcje-zrodla/zgoda')
  },
  potwierdzInterakcjeZgoda(wersja) {
    return axios.post('/api/auth/interakcje-zrodla/zgoda', { wersja })
  },
  getInterakcjeZrodla(ean) {
    return axios.post('/api/auth/interakcje-zrodla', { ean }, { timeout: 300000 })
  },
  // szablony recept lekarza (zestawy leków) — serwer: api/medicines/recepty-szablony.ts
  getSzablony() {
    return axios.get('/api/auth/recepty-szablony')
  },
  saveSzablon(szablon) {
    return axios.post('/api/auth/recepty-szablony', szablon)
  },
  deleteSzablon(nazwa) {
    return axios.delete('/api/auth/recepty-szablony', { data: { nazwa } })
  },

  savePresDetails(presObj, statusCallback) {
    // console.log(JSON.stringify(presObj), 'pres obj')
    // statusCallback(0, true, 'prescription succesfully added')
    // statusCallback(1, false, 'Error Issuing prescription due to invalid patient Number')
  }
}
